import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const workoutApi = createApi({
  reducerPath: 'workouts',
  tagTypes: ['Workout'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchWorkouts: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Workout', id: 'LIST' },
                ...result.map((r) => ({ type: 'Workout', id: r.id })),
              ]
            : [{ type: 'Workout', id: 'LIST' }],
        query: (coach) => ({
          url: `?resource=workout&coach=eq.${coach}&order=id.desc`,
          method: 'GET',
        }),
      }),

      fetchAvailableWorkouts: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Workout', id: 'LIST' },
                ...result.map((r) => ({ type: 'Workout', id: r.id })),
              ]
            : [{ type: 'Workout', id: 'LIST' }],
        query: (coach) => ({
          url: `?resource=workout&coach=eq.${coach}&program=is.null`,
          method: 'GET',
        }),
      }),

      createWorkout: builder.mutation({
        invalidatesTags: [{ type: 'Workout', id: 'LIST' }],
        query: (data) => ({
          url: `?resource=workout`,
          method: 'POST',
          body: data,
          headers: {
            Prefer: 'return=representation',
            'Content-Type': 'application/json',
          },
        }),
      }),

      updateWorkout: builder.mutation({
        invalidatesTags: (result, error, { id: workoutId }) => [
          { type: 'Workout', id: workoutId },
          { type: 'Workout', id: 'LIST' },
        ],
        query: ({ id: workoutId, submitData }) => ({
          url: `?resource=workout&id=eq.${workoutId}`,
          method: 'PATCH',
          body: submitData,
          headers: {
            Prefer: 'return=representation',
            'Content-Type': 'application/json',
          },
        }),
      }),

      deleteWorkout: builder.mutation({
        invalidatesTags: (result, error, workoutId) => [
          { type: 'Workout', id: workoutId },
          { type: 'Workout', id: 'LIST' },
        ],
        query: (workoutId) => ({
          url: `?resource=workout&id=eq.${workoutId}`,
          method: 'DELETE',
        }),
      }),

      fetchWorkout: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Workout', id: arg }],
        query: (workoutId) => ({
          url: `?resource=workout&id=eq.${workoutId}&select=*,workout_exercise(*,exercise(*),set_objective(*))`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchWorkoutsQuery,
  useCreateWorkoutMutation,
  useUpdateWorkoutMutation,
  useDeleteWorkoutMutation,
  useFetchWorkoutQuery,
  useLazyFetchWorkoutQuery,
  useFetchAvailableWorkoutsQuery,
} = workoutApi;

export { workoutApi };
